<template>
  <div class="text-center">
    <v-dialog v-model="isShowDialog" width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-show="isLogin" class="ma-2" color="primary" text v-bind="attrs" v-on="on">
          ログアウト
          <v-icon dark right> mdi-logout </v-icon>
        </v-btn>
      </template>
      <v-card :loading="isLoading">
        <v-card-title class="ma-0 pa-5 justify-center text-h6"> ログアウト </v-card-title>
        <v-card-subtitle class="mx-10 pa-0 text-left">
          <p class="ma-0 pa-0 text-body-2">
            ログアウトしますか？<br />ログアウトするとカートをクリアします。
          </p>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="closeDialog" class="mx-2">いいえ</v-btn>
          <v-btn color="primary" depressed @click="logout" class="mx-2">はい</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * 認証状態を取得する
     */
    isLogin: {
      cache: false,
      get() {
        return this.$store.getters['partner/isAuthenticated'];
      },
    },
  },
  data() {
    return {
      isShowDialog: false,
      isLoading: false,
    };
  },
  methods: {
    /**
     * ダイアログを閉じる
     */
    closeDialog: function () {
      // ダイアログを非表示にする
      this.isShowDialog = false;
    },
    /**
     * ログアウトする
     */
    logout: async function () {
      this.isLoading = true;
      try {
        const res = await this.$store.dispatch('partner/signout');
        // console.log(`res:${JSON.stringify(res)}`);
        if (res.success) {
          // 商品カテゴリ一覧を取得する
          await this.$store.dispatch('productCategory/getProductCategories');
          // 商品一覧を取得する
          await this.$store.dispatch('product/getProducts');
          // 注文情報をリセットする
          this.$store.commit('shoppingOrder/reset');
          // ダイアログを非表示にする
          this.closeDialog();
          // 商品選択画面に戻る
          if (this.$route.path !== '/') this.$router.push('/');
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/debug.scss';
</style>
